import cx from 'classnames'
import { times } from 'lodash'
import { observer } from 'mobx-react-lite'
import { type EditorView } from 'prosemirror-view'
import { Fragment } from 'react'
import { useDetectKeyDown } from 'utils/hookUtils'
import Styles from './WrapColumns.module.scss'
import { useColumns } from './useColumns'

export const WrapColumns = observer(
  ({
    view,
    handleArrowKeys,
    unStyled = false,
    horizontal = false,
    hideTitle = false,
    inlineLabels = false,
  }: {
    view: EditorView
    handleArrowKeys: boolean
    unStyled?: boolean
    horizontal?: boolean
    hideTitle?: boolean
    inlineLabels?: boolean
  }) => {
    const { _onSelectCol, columnCount } = useColumns({ view })

    useDetectKeyDown(
      ['ArrowUp', 'ArrowDown'],
      (e: KeyboardEvent) => {
        if (!handleArrowKeys) {
          return
        }
        e.preventDefault()
        e.stopImmediatePropagation()
        if (e.key === 'ArrowUp') {
          _onSelectCol(Math.max(1, columnCount - 1))()
        } else if (e.key === 'ArrowDown') {
          _onSelectCol(Math.min(3, columnCount + 1))()
        }
      },
      undefined,
      true,
    )

    const generateColBtns = (n: number) => {
      return (
        <div
          className={cx(Styles.row, { [Styles.horizontalRow]: horizontal, [Styles.active]: columnCount === n })}
          onClick={_onSelectCol(n)}
        >
          {times(n, (i) => {
            return (
              <Fragment key={`colBtn-${i}`}>
                <div className={Styles.colBtn} />
                {n > 1 && i < n - 1 && <div className={Styles.colBtnSpacer} />}
              </Fragment>
            )
          })}
          {inlineLabels && <div className={Styles.inlineLabel}>{`${n} ${n === 1 ? 'column' : 'columns'}`}</div>}
        </div>
      )
    }

    return (
      <div
        className={cx(Styles.WrapColumns, {
          [Styles.WrapColumnsStyled]: !unStyled,
          [Styles.horizontal]: horizontal,
        })}
      >
        {!hideTitle && <div className={Styles.title}>Columns</div>}
        {generateColBtns(1)}
        {generateColBtns(2)}
        {generateColBtns(3)}
      </div>
    )
  },
)
